import { BaseLocalStorageApi } from './BaseLocalStorageApi';
import { eApiTags } from '../eApiTags';
import { ITransactionInformationData } from './ITransactionInformationData';
import { ILocalStorageData } from './ILocalStorageData';

export const TransactionInformationStorageApi = BaseLocalStorageApi.injectEndpoints({
  endpoints: (build) => ({
    getTransactionInformation: build.query<ILocalStorageData<ITransactionInformationData>, void>({
      query: () => ({
        url: eApiTags.TransactionInformation,
        method: 'GET',
      }),
      providesTags: [eApiTags.TransactionInformation],
    }),
    setTransactionInformation: build.mutation<
      ILocalStorageData<ITransactionInformationData>,
      ITransactionInformationData | null
    >({
      query: (body) => ({
        url: eApiTags.TransactionInformation,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [eApiTags.TransactionInformation],
    }),
  }),
});

export const { useGetTransactionInformationQuery, useSetTransactionInformationMutation } =
  TransactionInformationStorageApi;
